import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { DataService } from 'src/app/services/data.service';
import { DISPLAY_STATUS_OBJECT, STATUS_OBJECT } from 'src/app/dummy/status';
import { ConvertService } from 'src/app/services/convert.service';
import { COLLECTION_NAME } from 'src/app/dummy/app';
import { IReadingData } from 'src/app/interfaces/book-store';
import { BookstoreStore } from 'src/app/stores/bookstore/bookstore.store';

@Component({
  selector: 'app-add-reading-text-convertor',
  templateUrl: './add-reading-text-convertor.component.html',
  styleUrls: ['./add-reading-text-convertor.component.scss']
})
export class AddReadingTextConvertorComponent implements OnInit {
  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;
  TITLE = "Convert Text Book Format"

  form: FormGroup;

  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  isCreate: boolean = false;


  CONVERT_TEXT: any;
  constructor(
    public dialogRef: MatDialogRef<AddReadingTextConvertorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private auth: AuthStore,
    public store: BookstoreStore,
    private snackBar: MatSnackBar,
    private ds: DataService,
  ) { }


  ngOnInit() {
    this.form = this.fb.group({
      name: [null, Validators.compose([Validators.required, this.htmlText.bind(this)])],
    })
  }

  htmlText(control: AbstractControl) {
    if (control && control.value) {
      const { value } = control;
      const text = value.replace(/<img[^>]*>/g, "").replace("↵",'');
      this.CONVERT_TEXT = text;
    }
  }

}
